import axios from "axios";

export const SUPPORT_TICKET = "support/ticket";

export const buildSupportTicketPayload = (values, hospitals = []) => {
  const hospital = hospitals.find((item) => String(item.id) === String(values.hospitalId));

  return {
    tipo_soporte: values.requestType === "Asesoría" ? "asesoria" : "incidencia",
    tipo_usuario: values.userType === "Aseguradora" ? "aseguradora" : "hospital",
    name: values.contactName.trim(),
    email: values.contactEmail.trim(),
    message: values.description.trim(),
    hospital_cve_hos: hospital ? Number(hospital.cveHos ?? hospital.cve_hos ?? hospital.id) : null,
    hospital_nombre: hospital ? hospital.hospitalName ?? hospital.name ?? hospital.nombre : null,
    folio_atc_plus: values.requestType === "Incidencia" ? values.folioAtcPlus.trim() : null,
    modulo: values.requestType === "Incidencia" ? values.module : null,
    detalle_incidencia: values.requestType === "Incidencia" ? values.incidentDetail : null,
    contacto_telefono: values.contactAlsoByPhone,
    telefono: values.contactAlsoByPhone ? values.contactPhone.trim() : null,
  };
};

export const storeHelpRequest = (values, hospitals) =>
  axios.post(SUPPORT_TICKET, buildSupportTicketPayload(values, hospitals));
